import platform from '../../../../../shared/Platform';
import { createSendMessage } from './createSendMessage';

const options = {
  targetWindow: window.parent,
  targetOrigin: '*',
  shouldUseWebKit: platform.isIOSView(),
  webkitHandlerName: platform.isIOSView() ? 'assessments' : '',
};

export const sendMessageWithMessageOnly = createSendMessage(options);
